var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMosaicNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.33333,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16.6667,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6665,
    y: 2,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6665,
    y: 9.33333,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6665,
    y: 16.6667,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3335,
    y: 2,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3335,
    y: 9.33333,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3335,
    y: 16.6667,
    width: 6.66667,
    height: 5.33333,
    rx: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicNine);
export default __webpack_public_path__ + "static/media/mosaic-nine.f028c00461d0cfd0f0657244081e0d9f.svg";
export { ForwardRef as ReactComponent };